<template>
  <div class="app-faqs p-6">
    <div v-if="title" class="mb-4" v-html="title" />
    <BaseFaqs :faqs />
  </div>
</template>

<script lang="ts" setup>
  const { title = '', faqs = [] } = defineProps<{
    title?: string;
    faqs: {
      id: number | string;
      question: string;
      answer: string;
    }[];
  }>();
</script>

<style lang="postcss" scoped>
  .app-faqs {
    :deep(.base-faqs .tapp-accordion) {
      border-top: 1px solid var(--colors-gray-300);
    }

    :deep(.base-faqs .tapp-accordion:last-of-type) {
      border-bottom: 1px solid var(--colors-gray-300);
    }
  }
</style>
